/* globals lp,jui,Class */
module.exports = Class.create(
    lp.editor.panel.ElementPropertiesPanel,
    lp.editor.panel.ElementGeometryControls,
    lp.editor.panel.ElementBackgroundControlsNew,
    lp.editor.panel.ElementBorderControls,
    lp.ModuleComponent, {
      type: 'lp-pom-block',

      initialize: function($super) {
        $super();
        var self = this;

        this.modelChangeHandlers.push(function(e) {

          var accessor = e.data.accessor;
          var value = e.data.value;
          switch (accessor) {
            case 'geometry.fitWidthToPage':
              value = value || false;
              self.controls.apply.checkboxes.left.disabled = value;
              self.controls.apply.checkboxes.right.disabled = value;
              break;
            case 'geometry.margin.bottom':
              self.controls.marginBottom.setValue(value);
              break;
            case 'geometry.margin':
              // TODO-TR: what about value= 'auto'
              self.controls.marginBottom.setValue(
                (value && value.bottom) ? value.bottom : 0);
              break;
          }
        });


      },

      _addAutoLayoutControl: function() {
        this.autoLayoutPanel = new window.lp.editor.panel
          .AutoLayoutControl('page section', this._uiBinding).view();
        this.insert(this.autoLayoutPanel);
      },

      installUI: function($super) {
        $super();
        var self = this;

        if(window.editor.page.getConfigValue('allowAutoLayout')){
          this._addAutoLayoutControl();
        }

        var geometryPanel = this.insert(new jui.CollapsiblePanel({
          title       : 'Geometry',
          attributes  : {
            className : 'collapsible-panel panel-page-section-geometry'
          }
        }));
        var borderPanel = this.insert(new jui.CollapsiblePanel({
          title       : 'Border',
          attributes  : {
            className : 'collapsible-panel panel-page-section-border labels-above'
          }
        }));
        var backgroundPanel = this.insert(new jui.CollapsiblePanel({
          title       : 'Background',
          attributes  : {
            className : 'collapsible-panel panel-page-section-background'
          }
        }));

        this.installGeometryControls({
          insert: geometryPanel.insertContent.bind(geometryPanel),
          sizeOptions: {
            disableWidth: true
          }
        });

        this.controls.marginBottom = geometryPanel.insertContent(new jui.FormNumericInput({
          label   : 'Gap Below',
          onfocus : this.requestFocus.bind(this),
          onblur  : function(e) {
            self._uiBinding.onNext({
              type  : 'changeGapBelow',
              value : e.source.getValue() * 1
            });
          }
        }));

        this.installBorderControls({
          insert: borderPanel.insertContent.bind(borderPanel),
        });

        this.installBackgroundControls({
          insert: backgroundPanel.insertContent.bind(backgroundPanel),
          showFixed: true,
          showStretched: true
        });

        this._uiBinding.subscribeDomainEvents(this.domainEvents, this);
      },

      handleBorderCheckboxes: function(isDisabled) {
        var checkboxes = this.controls.apply.checkboxes;
        checkboxes.left.disabled = isDisabled;
        checkboxes.right.disabled = isDisabled;
        var model = this.element.model;

        if (isDisabled) {
          checkboxes.left.checked = false;
          checkboxes.right.checked = false;

          model.set(
            'geometry.savedBorderState.left',
            model.get('geometry.borderApply.left')
          );
          model.set(
            'geometry.savedBorderState.right',
            model.get('geometry.borderApply.right')
          );

          model.set('geometry.borderApply.left', false);
          model.set('geometry.borderApply.right', false);
        } else {
          if (model.exists('geometry.savedBorderState.left')) {
            model.set(
              'geometry.borderApply.left',
              model.get('geometry.savedBorderState.left')
            );
          } else {
            model.set('geometry.borderApply.left', true);
            model.set('geometry.savedBorderState.left', true);
          }

          if (model.exists('geometry.savedBorderState.right')) {
            model.set(
              'geometry.borderApply.right',
              model.get('geometry.savedBorderState.right')
            );
          } else {
            model.set('geometry.borderApply.right', true);
            model.set('geometry.savedBorderState.right', true);
          }

          checkboxes.left.checked = model.get('geometry.borderApply.left');
          checkboxes.right.checked = model.get('geometry.borderApply.right');
        }
      },

      syncUIControls: function($super, elm) {
        //TODO: Add spec and refactor;
        $super(elm);
        this.bindGeometryControlsToElement(elm);
        this.bindBackgroundControlsToElement(elm);
        this.bindBorderControlsToElement(elm);

        var fwtp = elm.model.exists('geometry.fitWidthToPage') &&
          elm.model.get('geometry.fitWidthToPage');

        if(this.element.page.getConfigValue('allowAutoLayout')){
          this.autoLayoutPanel.setVisible(elm.page.allowAutoLayout());
        }

        this.controls.apply.checkboxes.left.disabled = fwtp;
        this.controls.apply.checkboxes.right.disabled = fwtp;

        var margin = elm.model.getMargin();
        var marginBottom = typeof margin.bottom === 'undefined' ? 0 : margin.bottom;
        this.controls.marginBottom.setValue(marginBottom);
        this.controls.marginBottom.setVisible(elm.page.allowSectionMargins());

        this.controls.location.setVisible(
          this.element.page.getConfigValue('allowSectionBorderLocationControls')
        );

        this.controls.radiusContainer.setVisible(
          this.element.page.getConfigValue('allowSectionBorderRadiusControls')
        );
      },

      domainEvents: {
        changeGapBelow: function(ev) {
          var self = this;

          this.performModelUpdates(function() {
            self.element.model.setMargin({
              left   : 'auto',
              right  : 'auto',
              bottom : ev.value
            }, self.element.page.undoManager);
          });

          this.controls.marginBottom.setValue(ev.value); // Sync control
        }
      }
    });



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/modules/lp-block/block_element_properties_panel.js
// module id = 1079
// module chunks = 0